import { useTranslation } from 'react-i18next';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FormHeader } from 'components/_basic/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import {
  EstimatedTaxRateSection,
  ProfitAndLossProjectionFormTable,
} from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/components';

export const ProfitAndLossProjection: React.FC = () => {
  const { t } = useTranslation();

  const canAccess = useCheckSubSectionAccess(
    FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN,
    BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.PROFIT_AND_LOSS_PROJECTION,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('financialPlan.title')}
          badgeText={t('financialPlan.profitAndLossProjection.title')}
        />
      </FormSectionCard>

      <ProfitAndLossProjectionFormTable disabled={!canAccess} />

      <EstimatedTaxRateSection
        title={t('financialPlan.profitAndLossProjection.estimatedTaxRate')}
        disabled={!canAccess}
      />
    </>
  );
};
